import React, { useRef } from "react";
import config from "../config";
import { getZscalerURLParams } from "../utilities/utilities";

const ContinueButton = () => {
  const continueFormRef = useRef();
  const params = getZscalerURLParams();

  return (
    <div id="continue_container" className="accept_btn_cont">
      <form
        id="continue_form"
        action={config.services.zScalerUrl}
        ref={continueFormRef}
      >
        <button
          className="green continue-button"
          onClick={(evt) => {
            continueFormRef.current.submit();
          }}
        >
          Continue to Site
        </button>
        <input type="hidden" name="_sm_url" value={params.url} />
        <input type="hidden" name="_sm_rid" value={params.zsq} />
        <input type="hidden" name="_sm_cat" value="Caution" />
      </form>
    </div>
  );
};

export default ContinueButton;
